import React, { useRef, useEffect, useState } from "react";
import api from "../../services/api";

import errors, { IAliancaErrors } from "../../Utils/ExtractErrors";

import { Form, Modal, Button, Grid, Image, Dimmer, Segment, Divider } from "semantic-ui-react";
import { toast } from "react-toastify";

import ModalApp from "../../components/ModalApp";
import ImageZoom from "../../components/ImageZoom";
import ModalYesNo from "../../components/ModalYesNo";

import OrderRepository from "../../Repositories/OrderRepository";
import ImagemRepository from "../../Repositories/ImagesRepository";

import { IPedidoLiberacao, IImagem, eStatusLiberacao } from "../../interfaces";
import { GetUser } from "../../services/auth";
import CustomLoader from "../../components/CustomLoader";


interface State extends IPedidoLiberacao {
    images: IImagem[];
    liberacao: number;
    apiErrors: IAliancaErrors;
}

interface Props {
    pedidoId: string;
}

const initialState: State = {
    images: [],
    liberacao: 0,
    apiErrors: { errors: [] }
}

const ReciboPedido: React.FC<Props> = ({ pedidoId }) => {

    const [open, setOpen] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [state, setState] = useState<State>(initialState);
    const [selectedFiles, setSelectedFiles] = useState<File[]>([]);
    const [preview, setPreview] = useState<string[]>([]);

    const fileInputRef = useRef<HTMLInputElement>(null);

    const { role } = GetUser();

    const load = async () => {
        setLoading(true);

        try {

            const [liberacao, images] = await Promise.all([
                OrderRepository.GetById(pedidoId),
                ImagemRepository.GetByReferenceId(pedidoId)

            ]);

            setState(state => ({
                ...state,
                ...liberacao,
                images
            }));

        } catch (err) {
            if (err.response.status === 401) {
                window.location.href = "/";
            }

            const error = errors.getAllErrors(err.response.data);

            if (error !== undefined)
                toast(error, { position: "top-center", type: "error" });
        }
        setLoading(false);
    }

    const onButtonClick = () => {
        if (fileInputRef && fileInputRef.current) {
            fileInputRef.current.click();
        }
    }

    useEffect(() => {
        if (selectedFiles.length > 0) {
            let images: string[] = [];

            for (const file of selectedFiles) {
                images.push(URL.createObjectURL(file));
            }

            setPreview(preview => preview.concat(images));

            return () => {
                for (const image of images) { URL.revokeObjectURL(image) }
                setPreview([]);
            }
        }
    }, [selectedFiles])

    const onSelectFile = (e: any) => {
        if (!e.target.files || e.target.files.length === 0) {
            setSelectedFiles([])
            return

        }

        let files: File[] = [];
        files = files.concat(selectedFiles);

        for (const file of e.target.files) {
            files.push(file);
        }

        setSelectedFiles(files);
    }

    const onRemovePreview = (imageUrl: string, index: number) => {
        const images = preview.filter(x => x !== imageUrl);

        selectedFiles.splice(index, 1);

        URL.revokeObjectURL(imageUrl);
        setPreview(images);
    }

    const onRemove = async (id: string) => {
        await ImagemRepository.DeleteById(id);
        load();
    }

    const handleSubmitForm = async () => {
        setLoading(true);
        if (role !== "Admin" && role !== "Operador") {
            const hasTwoFiles = selectedFiles.length >= 2 || state.images.length >= 2;
            if (!hasTwoFiles) return toast("❌ É necessário inserir no mínimo 2 fotos.", { position: "top-center", type: "error" });
        }
        try {
            const response = await OrderRepository.UpdateLiberacao({
                id: pedidoId,
                orderPutModelLiberacao: { liberacao: state.liberacao }
            });
            const data = new FormData();

            for (const file of selectedFiles) {
                data.append("files", file);
            }

            setSelectedFiles([]);
            setPreview([]);

            await api.post(`imagem/${pedidoId}`, data);
            toast(`💾 ${response.message}`, { position: "top-center", type: "success" });

            setOpen(false);
            setLoading(true);
        } catch (err) {
            if (err.response.status === 401) {
                window.location.href = "/";
            }

            setState({ ...state, apiErrors: err.response.data });

            const error = errors.getAllErrors(err.response.data);

            if (error !== undefined)
                toast(error, { position: "top-center", type: "error" });
        }
        setLoading(false);
    }

    const handleOpen = () => {
        load();

        setOpen(true);
    }

    const handleClose = () => {
        setState({ ...state, apiErrors: { errors: [] } });
        setOpen(false);
        setSelectedFiles([]);
        setPreview([]);
    }

    const editarContent = (
        <Modal.Content>
            {loading &&
                <Dimmer active inverted>
                    <CustomLoader />
                </Dimmer>}
            {!loading &&
                <>
                    <Form>
                        {
                            role === "Admin" &&
                            <Grid.Row>
                                <Form.Field width="16">
                                    <label>Alterar status:</label>
                                    <Form.Group>
                                        <Button.Group fluid>
                                            <Button
                                                color={state.liberacao === 0 ? "red" : "grey"}
                                                content="Faltando Fotos"
                                                onClick={() => { setState({ ...state, liberacao: eStatusLiberacao.Normal }) }}
                                            />
                                            <Button.Or text="?" />
                                            <Button
                                                color={state.liberacao === 1 ? "brown" : "grey"}
                                                content="Pendente"
                                                onClick={() => { setState({ ...state, liberacao: eStatusLiberacao.Pendente }) }}
                                            />
                                            <Button.Or text="?" />
                                            <Button
                                                color={state.liberacao === 2 ? "green" : "grey"}
                                                content="Liberado"
                                                onClick={() => { setState({ ...state, liberacao: eStatusLiberacao.Liberado }) }}
                                            />
                                        </Button.Group>
                                    </Form.Group>
                                </Form.Field>
                            </Grid.Row>
                        }
                        <Grid.Row>
                            <Grid.Column>
                                <Form.Group>
                                    <strong>
                                        <p>
                                            FOTOS NECESSÁRIAS:<br />
                                            - PEDIDO ASSINADO, APARECENDO Nº E ASSINATURA.<br />
                                            - REPRESENTANTE, SEGURANDO O PEDIDO ASSINADO. <br />
                                        </p>
                                    </strong>
                                </Form.Group>
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row>
                            <Form.Group>
                                <Button
                                    content="Selecionar fotos"
                                    icon="images"
                                    fluid
                                    onClick={onButtonClick}
                                    color="black"
                                />
                                <input
                                    ref={fileInputRef}
                                    type="file"
                                    hidden
                                    multiple
                                    accept="image/*"
                                    onChange={onSelectFile}
                                />
                            </Form.Group>
                        </Grid.Row>
                        {
                            state.images.length > 0 &&
                            <>
                                <Divider />
                                <Segment placeholder>
                                    <Grid columns={1} stackable>
                                        <Grid.Row>
                                            <Grid.Column>
                                                <Grid columns={4} doubling textAlign="center">
                                                    {state.images.length > 0 &&
                                                        state.images.map((x, index) =>
                                                            <Grid.Column key={`image-${index}`}>
                                                                <Image
                                                                    fluid
                                                                    label={<ImageZoom imagePath={`${api.defaults.baseURL}/images/${x.arquivo}`} />}
                                                                    src={`${api.defaults.baseURL}/images/${x.arquivo}`}
                                                                />
                                                                <ModalYesNo
                                                                    trigger={<Button icon="trash" color="red" attached="bottom" disabled={(role !== "Admin" && role !== "Operador")} />}
                                                                    header="Apagar"
                                                                    content="Deseja realmente apagar esta foto?"
                                                                    onSuccess={() => onRemove(x.id || "")}
                                                                />
                                                            </Grid.Column>
                                                        )}
                                                </Grid>
                                            </Grid.Column>
                                        </Grid.Row>
                                    </Grid>
                                </Segment>
                            </>
                        }
                        {
                            preview.length > 0 &&
                            <>
                                <Divider />
                                <Segment placeholder>
                                    <Grid columns={1} stackable>
                                        <Grid.Row>
                                            <Grid.Column>
                                                <Grid columns={4} doubling textAlign="center">
                                                    {preview.length > 0 &&
                                                        preview.map((x, index) =>
                                                            <Grid.Column key={`image-${index}`}>
                                                                <Image
                                                                    fluid
                                                                    label={<ImageZoom imagePath={x} />}
                                                                    src={x}
                                                                />
                                                                <ModalYesNo
                                                                    trigger={<Button icon="trash" color="red" attached="bottom" />}
                                                                    header="Apagar"
                                                                    content="Deseja realmente apagar esta foto?"
                                                                    onSuccess={() => onRemovePreview(x, index)}
                                                                />
                                                            </Grid.Column>
                                                        )}
                                                </Grid>
                                            </Grid.Column>
                                        </Grid.Row>
                                    </Grid>
                                </Segment>
                            </>
                        }
                    </Form>
                </>}
        </Modal.Content >
    );

    return (
        <ModalApp
            open={open}
            handleOpen={handleOpen}
            handleClose={handleClose}
            title={`Anexar Fotos do pedido`}
            content={editarContent}
            trigger={{
                icon: "picture",
                color: "green"
            }}
            onSuccess={{ content: "Salvar", func: handleSubmitForm }}
        />
    );
};

export default ReciboPedido;
